export default {
  common: {
    loginTitle: 'Login',
    createPasswordTitle: 'Create your Password',
    forgetPasswordTitle: 'Forgot Password',
    resetPasswordTitle: 'Reset Password',
    questionnaireTitle: 'New Hire Paperwork',
    loginError: 'Your username or password is incorrect',
    questionnaireFinished: 'Hire Paperwork Finished',
    questionnaireFinishedText1: 'Congratulations on completing all the questions',
    toHomeBtn: 'Home',
    email: 'Email',
    alertTitle: 'Note',
    btn: {
      forgetPassword: 'forgot password',
      reset: 'Reset'
    },
    message: {
      resetEmailSuccess: 'Reset password email has been sent successfully. Please note that check.',
      wrongEmail: 'Unable to reset the password, please check the email address.'
    }
  },
  nestle: {
    error: {
      fileNotUpload: 'Attachment is required',
      fileSizeError: 'File size can not exceed 4MB',
      passwordTip: 'Password must contain small letter, capital letter and number, and at least 10 digit, symbol can only use _#@.-',
      passwordNotSame: 'Two passwords are not same',
      isRequired: 'This field cannot be empty',
      noSteps: 'Get no onboarding steps, please refresh and try again',
      serverError: 'Server internal error',
      uploadError: 'Upload file failed, please try again',
      uploadSuccess: 'Upload file successfully',
      phoneError: 'Phone number format is invalid',
      birthIsNeeded: 'Date of Birth is required.',
      ageTooSmall: 'You have indicated that you are under the age of 15. You must be at least 15 years old to work for our company.',
      nameNotEn: 'Please check and ensure your name is in Pinyin or English before click to next page',
      nationalIDIssueDateIsNeeded: 'National ID issue date is required.',
      nationalIDExpireDateIsNeeded: 'National ID expiry date is required.',
      nationalIDExpireLargeThanIssue: 'National ID issue date should be less than expiry date.',
      nationalIDExpireLargeThanNow: 'National ID expiry date should be in future.',
      nationalIDRegex: 'Please enter a valid {nationID}. Use The Format {format}',
      mustSelected: 'This field must be selected',
      tryAgain: 'Please try again'
    },
    upload: 'Upload',
    fileChangedButNoUpload: 'The file has been modified but not uploaded. Are you sure you want to leave?',
    year: '{year} ',
    confirm: 'Confirm',
    language: 'Language',
    completeMyPaperwork: 'Complete my paperwork',
    learning: 'Learning',
    myFirstDay: 'My first day',
    createPassword: 'Create your Password',
    userName: 'User Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    reEnterPassword: 'Re-Enter Password',
    agreeStatement: "I've read & accept the Data Privacy Consent Statement",
    statementTitle: 'Privacy Consent Statement',
    statementBody: `
    <div style="font-size: medium;">
    The following declaration is presented before logging into the pre-boarding portal, from the link in the Welcome letter.
    <br><br>
    <div style="text-align: center;font-size: large;">Declaration</div>
    <br><br>
    By signing this declaration, I hereby acknowledge and agree that:
    <br><br>
    - By entering the global Onboarding portal, I may have access to confidential information proprietary to Nestlé S.A., and to any subsidiaries and affiliates that are, as of any determination date, controlled by or are under common control with Nestlé S.A. and their respective successors and assignees (together: “Nestlé”). Such confidential information may concern Nestlé’s business, operations, employees, finances, proprietary products and processes, methods, know-how, manufacturing processes, systems improvements, research and development projects, technology, technical and commercial data, drawings, specifications, business plans and other information regarding the business of Nestlé which is not readily available to the public.
    <br><br>
    - I undertake to keep such information confidential and not to disclose it directly or indirectly to any third party, nor to use it for any purpose other than preparing my future employment at Nestlé, without Nestlé’s prior written consent.
    <br><br>
    - This obligation of confidentiality shall apply as from my acceptance of the present declaration until the start date of my employment at Nestlé, and will remain binding during and after the end of my employment at Nestlé for as long as Nestlé has not released the relevant confidential information in its entirety into the public domain.
    <br><br>
    - My unauthorized disclosure of confidential information could result in harm to Nestlé and may subject me to legal action for damages, without prejudice to Nestlé’s other rights and remedies it may have in respect of the breach of this undertaking under the applicable law.
    </div>
    `,
    toEmployeePortal: 'Go To Employee Portal',
    createPasswordTitle: 'Create your Password',
    paperworkTitle: 'New Hire Paperwork',
    back: 'Back',
    cancel: 'Cancel',
    next: 'Next',
    finish: 'Finish',
    submit: 'Submit',
    newHirePaperwork: 'New Hire Paperwork',
    paperworkStepZeroText1: 'Please fill out the information on the following wizards.',
    paperworkStepZeroText2: 'Use buttons on the bottom of wizard for navigation.',
    paperworkStepZeroText3: 'Press "Cancel" to get back to paperwork later, previously entered information will be saved.',
    followUs: 'Follow us on <a href="http://www.nestle.com/change-country">social media</a>. Find your country\'s specific channels by visiting the home page and selecting your market.',
    donnotBeShared: 'The content on this Onboarding site is reserved for use by you only, as a new employee. For copyright reasons, the content cannot be shared outside Nestlé.',
    learningPage: {
      learning: 'Learning',
      introduction: 'This Learning section provides you with all relevant information you need to properly start your journey within Nestlé.',
      ourHistory: 'Our history',
      ourHistoryDescription: '…as told by two of our historians at the exact spot of our first factory!',
      ourPurpose: 'Our Purpose & Values',
      ourPurposeDescription: '... are the foundation of what we do and provide guidance to contribute to our long term success.',
      ourEnvironment: 'Our work environment',
      ourEnvironmentDescription: '…and what you can expect from working at Nestlé.',
      messageFromMaurizioPatarnello: 'Message from Maurizio Patarnello',
      nestleWaters: 'Nestlé Waters',
      cerealPartnersWorldwide: 'Learn more about Cereal Partners Worldwide',
      messageFromJoeSivewright: 'Message from Joe Sivewright',
      purinaHistory: 'Purina - History',
      messageFromGregBehar: 'Message from Greg Behar',
      nestleHealthScience: 'Learn more about Nestlé Health Science',
      nestleNespresso: 'Nestlé Nespresso'
    },
    landingPage: {
      title: 'Congratulations.',
      subtitle: 'We are happy to have you join our team.',
      introduction: 'The Pre-boarding site is the place where you can start getting to know us as a business and a place to work before your Day One.',
      subIntroduction: 'Start your Onboarding journey and get prepared for your first day!',
      welcome: 'Welcome to Nestlé',
      welcomeDescription: 'Watch the Welcome message from:',
      ourCEO: 'Mark Schneider, our CEO',
      paperwork: 'Complete my paperwork',
      paperworkDescription: 'In order to properly manage your entry into Nestlé, please complete this section within the next 3 days',
      myFirstDay: 'My first day',
      myFirstDayDescription: 'Find more information about your workplace',
      learning: 'Learning',
      learningDescription: 'Start to get familiar with our company’s culture and values',
      welcomeTitle: 'Welcome!',
      welcomeBody: `
      <div style="font-size: medium;">
      Congratulations. We are happy to have you join our team. This pre-boarding site will guide you through the procedures and requirements needed in order for you to officially join us. In addition, it includes helpful information for you to get to know us better before your arrival.
      <br><br>
      For your first action, please go to “Complete my paperwork” tab.
      </div>
      `,
      welcomeDontShow: "Don't show this again",
      welcomeCompletePaperwork: 'Complete my paperwork'
    },
    myFirstDayPage: {
      title: 'My First Day',
      introduction: 'The Pre-boarding site is the place where you can start getting to know us as a business and a place to work before your Day One. Start your Onboarding journey and get prepared for your first day!',
      gcr: 'Nestlé GCR',
      china: 'Nestlé Mainland China, GCR',
      hk: 'Nestlé Hong Kong SAR, GCR',
      tw: 'Nestlé Taiwan, GCR',
      information: 'Information you need to know'
    },
    myFirstDayPageCN: {
      title: 'My First Day',
      china: 'Nestlé Mainland China, GCR',
      information: 'Information you need to know',
      chinaWebSite: 'Nestlé China Website',
      gcrOffice: 'Nestlé GCR Head Office',
      linkedIn: 'Nestlé LinkedIn',
      cnWechatQR1: 'Nestlé CN Official Account',
      cnWechatQR2: 'Nestlé Recruitment Official Account'
    },
    myFirstDayPageTW: {
      title: 'My First Day',
      tw: 'Nestlé Taiwan, GCR',
      information: 'Information you need to know',
      twWebSite: 'Nestlé Taiwan Website',
      twOffice: 'Nestlé Taiwan Office',
      story: 'Nestlé Story',
      twYoutube: 'Nestlé Taiwan YouTube',
      twFacebook: 'Nestlé Taiwan Facebook'
    },
    myFirstDayPageHK: {
      title: 'My First Day',
      hk: 'Nestlé Hong Kong SAR, GCR',
      information: 'Information you need to know',
      hkWebSite: 'Nestlé HK Corporate Website',
      hkOffice: 'Nestlé Hong Kong Office (YL)',
      story: 'Nestlé Story'
    },
    paperworkHome: {
      title: 'Complete my paperwork',
      introduction: 'In this page you will find all the important paperwork that you need to complete before your Day One.',
      firstSubIntroduction: 'Our Company is committed to green technology and protecting our environment. To that end, new hire paperwork will be completed on this secure online platform when permitted by legal requirements.',
      secondSubIntroduction: 'The personal information you are providing will be used to prepare the paperwork for your arrival at Nestlé and form part of your employee file.',
      step: 'Step',
      firstStepTitle: 'Enter your information',
      firstStepIntroduction1: 'The system will only ask you to enter your information once through a series of pages.',
      firstStepIntroduction2: 'Some information is optional, some information is required. If you miss a required field, the portal will highlight it. At the bottom of each page you will see the following buttons – <b>Next, Back and Close</b>. You can click <b>Close</b> to save the information you have entered and continue at a later time.',
      firstStepIntroduction3: 'After you have completed your paperwork, you will still get a chance to review and edit your information.',
      secondStepTitle: 'Sign your documents',
      secondStepIntroduction1: 'Once you have completed your paperwork, the system may require an e-signature (if enabled in your country). If this is required, select the <b>"Click to Sign"</b> button and your forms will be automatically signed.',
      thirdStepTitle: 'Tips to get started',
      thirdStepIntroduction1: 'Make sure you have turned off all pop-up blockers and that you have Internet Explorer 9 or higher, and Adobe Reader 4.0 or higher installed on your PC.',
      thirdStepIntroduction2: 'If you are ready to get started, just click <b>Complete my Onboarding paperwork!</b>',
      contact: 'You can contact\u3000',
      start: 'Start now and complete your Onboarding paperwork',
      finished: 'Your Onboarding paperwork is complete'
    },
    nespresso: {
      title: 'Nespresso',
      introduction: 'Welcome to Nespresso',
      sectionTitle1: 'Jean-Marc Duvoisin, CEO Nestlé Nespresso',
      sectionTitle2: 'Learn more about Nespresso History',
      sectionTitle3: 'Nespresso Brand',
      sectionTitle4: 'Learn more about Nespresso Purpose & Values',
      sectionTitle5: 'Nespresso Priorities & Road Map'
    }
  }
}
